import type { VehicleCategoryCode } from '../types';

export const VEHICLE_CATEGORY_OPTIONS: { value: VehicleCategoryCode; label: string }[] = [
  { value: 'TRUCK', label: 'Тягач' },
  { value: 'TRAILER', label: 'Прицеп' }
];

export function vehicleCategoryLabel(code?: string | null): string {
  if (code === 'TRAILER') return 'Прицеп';
  return 'Тягач';
}
